export var CATALOG_PAYMENT_MODE = "CATALOG_PAYMENT_MODE";
export var CATALOG_STATUS_POLICY = "CATALOG_STATUS_POLICY";
export var CATALOG_CIVIL_STATUS = "CATALOG_CIVIL_STATUS";
export var CATALOG_BENEFICIARY_TYPE = "CATALOG_BENEFICIARY_TYPE";
export var CATALOG_INSURED_TYPE = "CATALOG_INSURED_TYPE";
export var CATALOG_REASON_CANCELLATION = "CATALOG_REASON_CANCELLATION";
export var CATALOG_SEXO = "CATALOG_SEXO";
export var CATALOG_STATUS_QUOTE = "CATALOG_STATUS_QUOTE";
export var CATALOG_ACCOUNT_TYPE = "CATALOG_ACCOUNT_TYPE";
export var STEP_INSURANCE = "insurance";
export var STEP_PLAN = "plan";
export var STEP_AUDIT = "auditPage";
export var STEP_PAYMENTMETHOD = "paymentMethod";
export var STEP_PAYMENTCONFIRMATION = "paymentConfirmation";
export var STEP_CLIENTRECORD = "clientRecord";
export var STEP_CUSTOMERFORM = "customerForm";
export var STEP_CONFIRMATIONFORM = "confirmationForm";
export var STEP_VEHICLEDETAILS = "VehicleDetails";
export var STEP_PLANDETAILS = "planDetails";
export var STEP_APPLICANTDECLARATION = "applicantDeclaration";
export var STEP_INITIALINFO = "initialInfo";
export var STEP_FINANCIALINFO = "financialInfo";
export var STEP_MEDICALINFORMATION = "medicalInfo";
export var STEP_APPLICANTINFORMATION = "applicantInformation";
